import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  top: 3.64%;
  @media only screen and (max-width: 768px) {
    top: 0;
  }
  .arrow-up {
    width: 0;
    height: 0;
    border-left: 1.2rem solid transparent;
    border-right: 1.3rem solid transparent;
    border-bottom: 2rem solid ${({ theme }) => theme.neutral.white};
  }
`;

export const ContentModalProfile = styled.div`
  position: relative;
  top: 3.64%;
  bottom: 75.77%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 8px;
  min-height: 32em;
  max-height: 35em;
  height: fit-content;
  width: 600px;
  max-width: 650px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.4em;
  }
  &::-webkit-scrollbar-thumb {
    background: #0008ff85;
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
  @media only screen and (max-width: 768px) {
    min-width: 100vw;
    min-height: 100vh;
    height: 100vh;
    width: 100vw;
    max-width: 100vw;
  }
`;

export const CloseModalProfile = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 40%;
  padding: 3px 10px;
  font-weight: 600;
  background-color: ${({ theme }) => theme.secondaryGrayLightSeven};
  cursor: pointer;
  justify-content: space-between;
  border-radius: 4px;
  min-height: 33px;
  a {
    color: ${({ theme }) => theme.neutral.black};
    text-decoration: none;
    background-color: transparent;
  }
  .align-right {
    padding: 0px 4px;
  }
  .close {
    position: absolute;
    right: 1%;
  }
`;

export const CloseIconSvg = styled.div`
  svg {
    width: 15px;
    height: 15px;
  }
`;

export const ContainerContentModal = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

export const ContentMenu = styled.div`
  background-color: ${({ theme }) => theme.secondaryGrayLightSeven};
  width: 40%;
  height: 100%;
  .Mui-selected {
    background-color: rgba(46, 46, 46, 0.08) !important;
  }
`;

export const TitleMenu = styled.p`
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
  margin-top: 1em;
  margin-bottom: 0.2em;
`;

export const DisplayNameMenu = styled.p`
  font-size: 1rem;
  text-align: center;
`;

export const ProfilePicture = styled.div`
  display: flex;
  justify-content: center;
`;

export const Picture = styled.div`
  display: flex;
  width: 2em;
  height: 2em;
  border-radius: 99px;
  background: ${({ bgColor, photo }) => (photo) ? "url("+photo+")" : bgColor};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  justify-content: center;
  align-items: center;
  color: ${({ bgColor, photo }) => (bgColor || photo ? "white" : "black")};
  font-size: ${({ valuePictureWidth }) => valuePictureWidth + "px"};
`;

export const ContentPreview = styled.div`
  width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const ContentPersonIcon = styled.div`
  width: 90%;
  height: 90%;
  border-radius: 99px;
  background-color: ${({ theme }) => theme.neutral.gray[200]};
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (min-width: 2000px) and (max-width: 3000px) {
    width: 3em;
    height: 3em;
  }
  .person-icon {
    color: #3b3b3b;
  }
`;